module.exports = __webpack_public_path__ + "img/pin-in-4.b0456ab4.svg";